const AboutUs = () => {
  return (
    <section id="about"className="section">
      <h2>About Us</h2>
      <div className="cards">
        {/* <div className="card"> */}
          <p className="about">
            <img  className="pic" src="/images/Anuraghalf1.png" alt="img"></img>
            Maths Wallah is a leading educational platform committed to providing high-quality courses and resources to students of Grade 1 to 10. Our mission is to make education accessible, affordable, and engaging for everyone.Maths Wallah started in 2020 on YouTube and has uploaded around 100 free video lectures for students of Grades 1 to 10. It has become a strong educational platform, helping students learn effectively. In addition to regular lessons, Maths Wallah also offers special courses for competitive exams like Sainik School and Navodaya at affordable prices.
            The main goal of Maths Wallah is to provide quality education in a smart and budget-friendly way. In today's time, education in schools has become very expensive, and many families can't afford it. Keeping this in mind, Maths Wallah aims to deliver good education to children at a low cost.

 
          </p>
        {/* </div> */}
      </div>
    </section>
  );
};

export default AboutUs;
